import { createDatasetSlice } from 'src/redux/helpers';
import { RequestMethod, pepApiRequest } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_SOLUTION_DASHBOARD_DETAILS,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_DASHBOARDS,
} from '../constants';
import { mapSolutionAssetDashboardsData } from './utils';

const api = ({ solutionId, twinId }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_SOLUTION_DASHBOARD_DETAILS, {
      solutionId,
    }),
    queryParams: { twinId },
  }).then((items) => mapSolutionAssetDashboardsData(items));

const solutionAssetDashboardsSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_DASHBOARDS,
});

export default solutionAssetDashboardsSlice;
